import React from 'react';

import CompletionTemplate from '../components/common/template/CompletionTemplate';
import { useCompletion } from '../Hooks/useCompletion';

const CompletionPage = ({ match }) => {
  const {
    ultrasoundInfo,
    paymentInfo,
    linkToOrderDetail,
    LinkToPath,
  } = useCompletion(match.params.id);

  return (
    <CompletionTemplate
      ultrasoundInfo={ultrasoundInfo}
      paymentInfo={paymentInfo}
      linkToOrderDetail={linkToOrderDetail}
      LinkToPath={LinkToPath}
    />
  );
};

export default CompletionPage;
